// test1343
(1343 && 0);
